var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScrollDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 56,
    viewBox: "0 0 53 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_563_19835)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5837 28.6108L49.6377 7.62884C50.7874 6.40728 50.7874 4.539 49.6377 3.38924C48.4881 2.23956 46.5479 2.23956 45.3981 3.38924L26.4997 22.2876L7.60126 3.38924C6.37966 2.23956 4.51166 2.23956 3.36166 3.38924C2.21206 4.53892 2.21206 6.4072 3.36166 7.62884L24.3437 28.6108C25.5653 29.7605 27.434 29.7605 28.5837 28.6108Z",
    fill: "#3F5497",
    fillOpacity: 0.6
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_563_19835)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5837 52.6108L49.6377 31.6288C50.7874 30.4073 50.7874 28.539 49.6377 27.3892C48.4881 26.2396 46.5479 26.2396 45.3981 27.3892L26.4997 46.2876L7.60126 27.3892C6.37966 26.2396 4.51166 26.2396 3.36166 27.3892C2.21206 28.5389 2.21206 30.4072 3.36166 31.6288L24.3437 52.6108C25.5653 53.7605 27.434 53.7605 28.5837 52.6108Z",
    fill: "url(#paint0_linear_563_19835)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_563_19835",
    x1: -11.9007,
    y1: 24.7755,
    x2: -4.03093,
    y2: 65.0811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_563_19835"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 52,
    fill: "white",
    transform: "matrix(0 1 -1 0 52.5 0)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_563_19835"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 52,
    fill: "white",
    transform: "matrix(0 1 -1 0 52.5 24)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollDown);
export default __webpack_public_path__ + "static/media/scroll-down.ea90e2d5ed55386f0193976bd97bf578.svg";
export { ForwardRef as ReactComponent };